var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-bubble",style:(_vm.style)},[(!_vm.image)?_c('span',[_vm._v(_vm._s(_vm.username ? _vm.username[0] : 'you'))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }